import useOmsenApiClient from "./clients/useOmsenApiClient";
import { useQuery } from "@tanstack/react-query";

export default function useOmsenIndustrialClassifications() {
  const client = useOmsenApiClient();

  const getOmsenIndustrialClassifications = async () => {
    const response = await client.apiOmsenIndustrialclassificationsGet();
    return response.data;
  };

  return useQuery(["omsenIndustrialClassifications"], getOmsenIndustrialClassifications, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
}
